import { createSlice } from "@reduxjs/toolkit";

const initialState = { open: true };

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setOpenMenu(state, action) {
      state.open = action.payload;
    },
  },
});
const { actions, reducer } = themeSlice;
export const { setOpenMenu } = actions;
export default reducer;
